import React from 'react';
import { IonButton } from '@ionic/react';
import { TimeFrameValue } from 'common/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { playerTypeEnum } from 'common/commonEnum';
import { TimeRangeOption } from 'config/Timeframes';
import { useHistory, useLocation } from 'react-router';

interface TimeRangeButtonsProps {
  timeRanges: TimeRangeOption[];
  activeRange: string;
  onTimeRangeChange: (value: TimeFrameValue) => void;
  isProUser: boolean;
}

const TimeRangeButtons: React.FC<TimeRangeButtonsProps> = ({
  timeRanges,
  activeRange,
  onTimeRangeChange,
  isProUser,
}) => {
  const history = useHistory();
  const location = useLocation();

  const handleClick = (value: TimeFrameValue, isLocked: boolean) => {
    if (isLocked) {
      history.push('/auth/stripe', { previousPage: location.pathname });
      return;
    }
    onTimeRangeChange?.(value);
  };

  return (
    <div className="time-buttons">
      {timeRanges.map((eachRange) => {
        const { label, value, playerTypeAccess } = eachRange
        const playerType = isProUser ? playerTypeEnum.slotCheckPro : playerTypeEnum.slotCheck;
        const isOptionAvailable = playerTypeAccess?.includes(playerType);
        const isLocked = isOptionAvailable ? false : true;
        return (
          <IonButton
            key={value}
            size="small"
            fill="outline" 
            className={`${value === activeRange ? 'secondary active' : 'secondary'} ${
              isLocked ? 'locked' : ''
            }`}
            onClick={() => handleClick(value, isLocked)}
          >
            {label}
            {isLocked && <FontAwesomeIcon icon={faLock} className="icon-lock" style={{ marginLeft: '5px', fontSize: '10px' }} />}
          </IonButton>
        );
      })}
    </div>
  );
};

export default TimeRangeButtons;
